import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/reno_static/video-marketing-guide/WalsheimLightSF-v3.woff2%22,%22weight%22:%22300%22},{%22path%22:%22../../public/reno_static/video-marketing-guide/WalsheimRegularSF-v2.woff2%22,%22weight%22:%22400%22}],%22display%22:%22swap%22,%22variable%22:%22--font-guide-walsheim%22}],%22variableName%22:%22guideWalsheim%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'guideWalsheim', 'guideWalsheim Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
